import React from 'react'

import Icon from './Icon'

const QueryLink = ({id, name, onSelect, onDelete}) => {
  return <li className="saved-query" >
    
    <a className="select-saved-query" onClick={ _ => onSelect(id)}> {name} </a>
    <a className="delete-saved-query" onClick={onDelete}> <Icon name="trash"/>  </a>
  </li>  
}

QueryLink.propTypes = {
  name: React.PropTypes.string.isRequired,
  id: React.PropTypes.number.isRequired,
  onSelect: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
}

export default QueryLink



/** WEBPACK FOOTER **
 ** ./app/components/QueryLink.js
 **/